import VueCookies from 'vue-cookies'

export default function getBrowserLocale(options = {}) :string {
  const defaultOptions = { countryCodeOnly: false, fallbackLocale: 'en' };
  const opt = { ...defaultOptions, ...options };

  const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;
  if (!navigatorLocale) {
    return opt.fallbackLocale;
  }

  const trimmedLocale = opt.countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim();
  return trimmedLocale;
}

export function getChoosenLanguage(): string | null {
  // @ts-ignore
  return VueCookies.get('language')
}

export function setChoosenLanguage(lng: string): void {
  // @ts-ignore
  return VueCookies.set('language', lng, 7 * 24 * 60 * 60) // 7d expiration
}